import Journey from "./Journey";

const baseSteps = [
    {
        target: '[data-tour="projects-list"]',
        content: "Your existing projects appear here.",
        placement: "bottom-start",
        skipBeacon: true,
    },
    {
        target: '[data-tour="project-search"]',
        content: "Use search to quickly find a project by name.",
        placement: "bottom-start",
        skipBeacon: true,
    },
    {
        target: '[data-tour="project-filters"]',
        content: "Use these filters to narrow the projects shown in the list.",
        placement: "bottom-start",
        skipBeacon: true,
    },
    {
        target: '[data-tour="filter-all"]',
        content: "Select All to view projects across all organizations.",
        placement: "bottom-start",
        skipBeacon: true,
    },
    {
        target: '[data-tour="create-project"]',
        content: "Create a new project from here whenever you are ready.",
        placement: "bottom-start",
        skipBeacon: true,
    },
];

const emptyProjectSteps = [
    baseSteps[4],
];

export const ProjectsPageTour = ({run = false, hasProjects = false, onFinish}) => (
    <Journey
        key={`${run}-${hasProjects}`}
        steps={hasProjects ? baseSteps : emptyProjectSteps}
        run={run}
        onFinish={onFinish}
    />
);

export default ProjectsPageTour;
